import { get, map } from 'lodash';
import { convertTimeZone } from '../../../../../common/utils/date_time_util';
import { DEFAULT_TIMEZONE } from '../../../../../common/config/api_constants';

export const getTemplates = (data, surveyType) => {
  let content;

  switch (surveyType) {
    case 'LaborBCSubstantiation':
      content = get(data, 'updateLaborBCSubstantiationSurveyTemplateNames', []);
      break;
    default:
      content = [];
  }
  return map(content, template => {
    return { label: template, value: template };
  });
};

export const getConfigureSurveyPayload = (state, surveyType) => {
  console.log('9999999999 getConfigureSurveyPayload  ', state, surveyType);
  return {
    templateDocumentId: {
      defaultValue: 'Labor Business Component Substantiation Survey',
    },
    releaseDate: {
      defaultValue: Date.parse(
        convertTimeZone(
          `${get(state, `LaborBCSubstantiation.releaseDate`).toString()}T00:00:00`,
          DEFAULT_TIMEZONE,
          'UTC',
        ).toString(),
      ).toString(),
    },
    dueDate: {
      defaultValue: Date.parse(
        convertTimeZone(
          `${get(state, `LaborBCSubstantiation.dueDate`).toString()}T23:59:59`,
          DEFAULT_TIMEZONE,
          'UTC',
        ).toString(),
      ).toString(),
    },
    surveyType,
  };
};
